'use strict';

import {Point2D} from '../util/Geometry.js';
import * as util from '../util/Common.js';
import * as domUtil from '../util/Dom.js';
import {Bounds, BoxDisposition} from '../content/BoxContent.js'
import {TiledImageResource, TiledImageInfo} from './TiledImageContent.js';
import {ContentViewSession} from '../viewer/ContentView.js';

const privateMap = util.createPrivateMapper();

export class IIIFCanvasResourceLoader {
  constructor(options){
    const pv = privateMap(this);
    pv.resourceLoaders = options.resourceLoaders;
  }

  load(canvasInfo, successCallback, params){
    const pv = privateMap(this);
    const queue = [];
    if (canvasInfo.items.length == 0) {
      if (params.failure) {
        params.failure(new Error('empty canvas'));
      }
      return;
    }
    util.each(canvasInfo.items, (image) => {
      queue.push(image);
    });
    const items = [];
    const loaderParams = Object.assign({}, params);
    function next(){
      if (queue.length == 0) {
        const resource = new IIIFCanvasResource(canvasInfo, items);
        successCallback(resource);
        return;
      }
      const v = queue.shift();
      const loader = pv.resourceLoaders[v.type];
      if (!loader){
        if (params.failure) {
          params.failure(new Error('loader not found. type:' + v.type));
        }
        return;
      }
      loader.load(v.source, function(resource){
        if (v.xywh) {
          resource.bounds.position.set(v.xywh.x - (canvasInfo.width / 2) + (v.xywh.width / 2), v.xywh.y - (canvasInfo.height / 2) + (v.xywh.height / 2))
          resource.bounds.size.set(v.xywh.width, v.xywh.height)
        }
        items.push(resource);
        next();
      }, loaderParams);
    }
    next();
  }
}

export class IIIFCanvasResource {
  constructor(canvasInfo, items){
    const pv = privateMap(this);
    pv.items = items;
    pv.size = new Point2D(canvasInfo.width, canvasInfo.height);
    pv.bounds = new Bounds();
    pv.bounds.position.set(0, 0);
    pv.bounds.size.copy(pv.size);
    pv.annotationLists = canvasInfo.annotationLists;
  }
  get annotationLists(){
    return privateMap(this).annotationLists;
  }

  get bounds(){
    return privateMap(this).bounds;
  }

  get type(){
    return 'iiifcanvas';
  }

  get size(){
    return privateMap(this).size.clone();
  }
  set size(size){
    const pv = privateMap(this);
    pv.size.copy(size)
    pv.bounds.size.copy(size)
  }
  get items(){
    return privateMap(this).items;
  }
}

export class IIIFCanvasRenderer {
  constructor(options){
    options = options ? options : {}
    const pv = privateMap(this);
    pv.renderers = options.renderers;
    this.backgroundColor = options.backgroundColor ? options.backgroundColor : '#333'
  }
  render(view, resource, control, session){
    if (!view || !resource || !control) {
      return;
    }
    const pv = privateMap(this);
    const ctx = view.context2d;
    const vc = view.center;
    const disposition = control.box.disposition;
    const bounds = resource.bounds;

    if (!session.itemSessions || session.itemSessions.length != resource.items.length) {
      session.itemSessions = [];
      session.renderers = [];
      // session.imageControls = [];
      util.each(resource.items, (item, idx) => {
        session.itemSessions[idx] = new ContentViewSession();
        session.renderers[idx] = pv.renderers[item.type];
      });
    }

    const angle = disposition.angle;
    const z = disposition.zoom;
    const sz = bounds.size.mul(z)
    const ofs = disposition.offset.sub(sz.div(2));

    // const ofs = bounds.position.mul(z).add(disposition.offset.sub(sz.div(2)));
    // const ofs = bounds.position.mul(z).add(disposition.offset.sub(sz.div(2)));
    bounds.position.mul(z)
    // const lt = bounds.position.mul(z).sub(zsz.div(2)).add(vc.add(ofs));

    const rotateCenter = vc;

    ctx.save()

    ctx.translate(rotateCenter.x, rotateCenter.y);
    ctx.rotate(angle);
    ctx.translate(-rotateCenter.x, -rotateCenter.y);

    const backgroundColor = resource.backgroundColor ? resource.backgroundColor : this.backgroundColor;
    ctx.fillStyle = backgroundColor;
    // ctx.fillRect(ofs.x + vc.x + 0.5, ofs.y + vc.y + 0.5, sz.x - 1, sz.y - 1);
    ctx.fillRect(ofs.x + vc.x, ofs.y + vc.y, sz.x, sz.y);

    ctx.restore()

    util.each(resource.items, (item, idx) => {
      const renderer = session.renderers[idx];
      if (!renderer) {
        return;
      }
      renderer.render(view, item, control, session.itemSessions[idx]);
    });
    return true;
  };
};
